export const pending = ["Pending", "pending"]
export const verificationRequired = ["Verification Required", "verification_required"]
export const restricted = ["Restricted", "restricted"]
export const blocked = ["Blocked", "blocked"]
export const active = ["Active", "active"]
export const userVerifying = ["User Verifying", "user_verifying"]

export const bankAccountStatus = [pending, verificationRequired, restricted, blocked, active, userVerifying]